export const ackoLogoLines = 'https://acko-cms.ackoassets.com/acko_Logo_Lines_e5554b55f1.svg'

export const MediaKitDescriptionMock = {
  title: 'Brand kit',
  description:
    'We keep things simple and smart. This page brings together the essentials to help you use our brand the right way.',
}

export const MediaKitImages = {
  hero: 'https://acko-cms.ackoassets.com/Card_Backgroud1_d13cadc48c.webp',
  fullWidth: 'https://acko-cms.ackoassets.com/full_Width_df801fee7f.webp',
  fullWidthMobile: 'https://acko-cms.ackoassets.com/full_Width_Mobile_c4d7d40f64.webp',
}

export const AboutAckoMock = {
  title: 'OUR STORY',
  subheading: 'About ACKO',
  description:
    'ACKO exists because we were tired. Tired of insurers treating people as policy numbers and people seeing insurance as a task. We knew insurance needed change or better yet, a revolution. \n\nSo we changed insurance: from the colleague who’s nice only when they need something to the friend who shows up at 3 AM, no questions asked. \n\nBecause that’s what we all deserve. Rock-solid support when the chips are not in your favour.',
  ctaText: 'Download the brand guide',
  url: 'https://acko-cms.ackoassets.com/ACKO_Brand_Guideline_b4fdf555b0.pdf',
  journey: 'brand_guide',
}

export const AckoIdentityMock = {
  title: 'The ACKO identity',
  description:
    'Multiple styles, one identity. Get the complete logo kit and keep ACKO looking sharp wherever it appears.',
  images: [
    {
      image: 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg',
      backgroundColor: '#FAFAFA',
    },
    {
      image: 'https://acko-cms.ackoassets.com/White_Acko_logo_f520681d98.svg',
      backgroundColor: '#463C7B',
    },
    {
      image: 'https://acko-cms.ackoassets.com/logo_fullblack_darktext_lightbg_horizontal_notagline_424da83d41.svg',
      backgroundColor: '#FCF2EF',
    },
  ],
  ctaText: 'Download the logo kit',
  url: 'https://acko-cms.ackoassets.com/Acko_Logo_Files_03dbe48485.zip',
  journey: 'logo_kit',
}
